// Traduzioni della sezione Sviluppatore (token API) del manager.
// Pattern gettext: la CHIAVE è la stringa italiana. Merge dopo account.en.js
// (EN) e dopo CORE (es/fr/de) in i18n/index.js, quindi eventuali sovrapposizioni
// vengono sovrascritte da qui senza errori di chiavi duplicate.

export const en = {
  'Scopes del tuo token': 'Your token scopes',
  "Ecco l'elenco degli scope autorizzati dal token": 'Here is the list of scopes authorized by the token',
  'Applicazione predefinita': 'Default application',
  'Modificare le informazioni': 'Edit information',
  'Nome': 'Name',
  'Descrizione': 'Description',
  'Conferma': 'Confirmation',
  'Sì, revoca': 'Yes, revoke',
  'Revocare veramente il token': 'Really revoke the token',
  'senza nome': 'unnamed',
  "? L'azione è irreversibile.": '? This action is irreversible.',
  'Caricamento…': 'Loading…',
  'Nessun token': 'No token',
  'Creazione': 'Created',
  'Scadenza': 'Expiry',
  'Ultimo utilizzo': 'Last used',
  'Ambiti': 'Scopes',
  'Illimitato': 'Unlimited',
  'Non ancora in uso': 'Not yet used',
  'scope': 'scopes',
  'Elimina il token': 'Delete the token',
  'Informazioni aggiornate': 'Information updated',
  'Token revocato': 'Token revoked',
  'Creazione di un token': 'Create a token',
  'Per creare il tuo token compila i campi sottostanti:': 'To create your token, fill in the fields below:',
  'Nome del token (facoltativo)': 'Token name (optional)',
  'Applicazione *': 'Application *',
  'Ambiti *': 'Scopes *',
  'Rimuovi': 'Remove',
  'Cercare uno scope': 'Search for a scope',
  'Tutti': 'All',
  'Tutti gli scope selezionati': 'All scopes selected',
  'Durata di validità *': 'Validity period *',
  '1 ora': '1 hour',
  '1 giorno': '1 day',
  '1 mese': '1 month',
  '6 mesi': '6 months',
  '1 anno': '1 year',
  'Descrizione (facoltativa)': 'Description (optional)',
  'Crea il token': 'Create the token',
  'Password di accesso': 'Account password',
  'Inserisci la password del tuo account per creare il token.': 'Enter your account password to create the token.',
  'Password di accesso *': 'Account password *',
  'Mostra password': 'Show password',
  'Errore durante la creazione': 'Error during creation',
  'Token creato con successo': 'Token created successfully',
  'Token': 'Token',
  'Ricordati di copiare il tuo token: in un secondo momento non sarà più accessibile.': 'Remember to copy your token: it will not be accessible again later.',
  'Copia': 'Copy',
  'Applicazioni': 'Applications',
  'Consulta gli accessi alle tue applicazioni': 'View access to your applications',
  'API NeoFlux': 'NeoFlux API',
  'Leggi la documentazione per gli sviluppatori': 'Read the developer documentation',
  '0 token API': '0 API tokens',
};

export const es = {
  'Scopes del tuo token': 'Los ámbitos de tu token',
  "Ecco l'elenco degli scope autorizzati dal token": 'Esta es la lista de ámbitos autorizados por el token',
  'Applicazione predefinita': 'Aplicación predeterminada',
  'Modificare le informazioni': 'Editar la información',
  'Nome': 'Nombre',
  'Descrizione': 'Descripción',
  'Conferma': 'Confirmación',
  'Sì, revoca': 'Sí, revocar',
  'Revocare veramente il token': '¿Revocar realmente el token',
  'senza nome': 'sin nombre',
  "? L'azione è irreversibile.": '? La acción es irreversible.',
  'Caricamento…': 'Cargando…',
  'Nessun token': 'Ningún token',
  'Creazione': 'Creación',
  'Scadenza': 'Vencimiento',
  'Ultimo utilizzo': 'Último uso',
  'Ambiti': 'Ámbitos',
  'Illimitato': 'Ilimitado',
  'Non ancora in uso': 'Aún no utilizado',
  'scope': 'ámbitos',
  'Elimina il token': 'Eliminar el token',
  'Informazioni aggiornate': 'Información actualizada',
  'Token revocato': 'Token revocado',
  'Crea un token': 'Crear un token',
  'Gestione dei token API': 'Gestión de tokens API',
  "L'API NeoFlux ti consente di gestire i prodotti tramite le tue interfacce senza passare dal Manager.": 'La API de NeoFlux te permite gestionar tus productos desde tus propias interfaces sin pasar por el Manager.',
  'Consulta la documentazione.': 'Consulta la documentación.',
  "Un token consente di consultare l'API NeoFlux con il proprio account utente. Il codice ottenuto è": 'Un token permite acceder a la API de NeoFlux con tu cuenta de usuario. El código obtenido es',
  'riservato': 'confidencial',
  'e non deve essere divulgato per nessuna ragione.': 'y no debe divulgarse por ningún motivo.',
  'token': 'tokens',
  "Cerca un'applicazione o uno scope": 'Buscar una aplicación o un ámbito',
  'Creazione di un token': 'Creación de un token',
  'Per creare il tuo token compila i campi sottostanti:': 'Para crear tu token, completa los campos siguientes:',
  'Nome del token (facoltativo)': 'Nombre del token (opcional)',
  'Applicazione *': 'Aplicación *',
  'Ambiti *': 'Ámbitos *',
  'Rimuovi': 'Quitar',
  'Cercare uno scope': 'Buscar un ámbito',
  'Tutti': 'Todos',
  'Tutti gli scope selezionati': 'Todos los ámbitos seleccionados',
  'Durata di validità *': 'Duración de validez *',
  '1 ora': '1 hora',
  '1 giorno': '1 día',
  '1 mese': '1 mes',
  '6 mesi': '6 meses',
  '1 anno': '1 año',
  'Descrizione (facoltativa)': 'Descripción (opcional)',
  'Crea il token': 'Crear el token',
  'Password di accesso': 'Contraseña de acceso',
  'Inserisci la password del tuo account per creare il token.': 'Introduce la contraseña de tu cuenta para crear el token.',
  'Password di accesso *': 'Contraseña de acceso *',
  'Mostra password': 'Mostrar contraseña',
  'Errore durante la creazione': 'Error durante la creación',
  'Token creato con successo': 'Token creado con éxito',
  'Token': 'Token',
  'Ricordati di copiare il tuo token: in un secondo momento non sarà più accessibile.': 'Recuerda copiar tu token: más adelante ya no será accesible.',
  'Copia': 'Copiar',
  'Applicazioni': 'Aplicaciones',
  'Consulta gli accessi alle tue applicazioni': 'Consulta los accesos a tus aplicaciones',
  'API NeoFlux': 'API NeoFlux',
  'Leggi la documentazione per gli sviluppatori': 'Lee la documentación para desarrolladores',
  '0 token API': '0 tokens API',
};

export const fr = {
  'Scopes del tuo token': 'Les scopes de votre jeton',
  "Ecco l'elenco degli scope autorizzati dal token": 'Voici la liste des scopes autorisés par le jeton',
  'Applicazione predefinita': 'Application par défaut',
  'Modificare le informazioni': 'Modifier les informations',
  'Nome': 'Nom',
  'Descrizione': 'Description',
  'Conferma': 'Confirmation',
  'Sì, revoca': 'Oui, révoquer',
  'Revocare veramente il token': 'Révoquer vraiment le jeton',
  'senza nome': 'sans nom',
  "? L'azione è irreversibile.": " ? L'action est irréversible.",
  'Caricamento…': 'Chargement…',
  'Nessun token': 'Aucun jeton',
  'Creazione': 'Création',
  'Scadenza': 'Expiration',
  'Ultimo utilizzo': 'Dernière utilisation',
  'Ambiti': 'Portées',
  'Illimitato': 'Illimité',
  'Non ancora in uso': 'Pas encore utilisé',
  'scope': 'scopes',
  'Elimina il token': 'Supprimer le jeton',
  'Informazioni aggiornate': 'Informations mises à jour',
  'Token revocato': 'Jeton révoqué',
  'Crea un token': 'Créer un jeton',
  'Gestione dei token API': 'Gestion des jetons API',
  "L'API NeoFlux ti consente di gestire i prodotti tramite le tue interfacce senza passare dal Manager.": "L'API NeoFlux vous permet de gérer vos produits depuis vos propres interfaces sans passer par le Manager.",
  'Consulta la documentazione.': 'Consultez la documentation.',
  "Un token consente di consultare l'API NeoFlux con il proprio account utente. Il codice ottenuto è": "Un jeton permet d'accéder à l'API NeoFlux avec votre compte utilisateur. Le code obtenu est",
  'riservato': 'confidentiel',
  'e non deve essere divulgato per nessuna ragione.': 'et ne doit être divulgué sous aucun prétexte.',
  'token': 'jetons',
  "Cerca un'applicazione o uno scope": 'Rechercher une application ou un scope',
  'Creazione di un token': "Création d'un jeton",
  'Per creare il tuo token compila i campi sottostanti:': 'Pour créer votre jeton, remplissez les champs ci-dessous :',
  'Nome del token (facoltativo)': 'Nom du jeton (facultatif)',
  'Applicazione *': 'Application *',
  'Ambiti *': 'Portées *',
  'Rimuovi': 'Supprimer',
  'Cercare uno scope': 'Rechercher un scope',
  'Tutti': 'Tous',
  'Tutti gli scope selezionati': 'Toutes les portées sélectionnées',
  'Durata di validità *': 'Durée de validité *',
  '1 ora': '1 heure',
  '1 giorno': '1 jour',
  '1 mese': '1 mois',
  '6 mesi': '6 mois',
  '1 anno': '1 an',
  'Descrizione (facoltativa)': 'Description (facultative)',
  'Crea il token': 'Créer le jeton',
  'Password di accesso': "Mot de passe d'accès",
  'Inserisci la password del tuo account per creare il token.': 'Saisissez le mot de passe de votre compte pour créer le jeton.',
  'Password di accesso *': "Mot de passe d'accès *",
  'Mostra password': 'Afficher le mot de passe',
  'Errore durante la creazione': 'Erreur lors de la création',
  'Token creato con successo': 'Jeton créé avec succès',
  'Token': 'Jeton',
  'Ricordati di copiare il tuo token: in un secondo momento non sarà più accessibile.': 'Pensez à copier votre jeton : il ne sera plus accessible par la suite.',
  'Copia': 'Copier',
  'Applicazioni': 'Applications',
  'Consulta gli accessi alle tue applicazioni': 'Consultez les accès à vos applications',
  'API NeoFlux': 'API NeoFlux',
  'Leggi la documentazione per gli sviluppatori': 'Lire la documentation pour les développeurs',
  '0 token API': '0 jeton API',
};

export const de = {
  'Scopes del tuo token': 'Die Scopes deines Tokens',
  "Ecco l'elenco degli scope autorizzati dal token": 'Hier die Liste der vom Token autorisierten Scopes',
  'Applicazione predefinita': 'Standardanwendung',
  'Modificare le informazioni': 'Informationen bearbeiten',
  'Nome': 'Name',
  'Descrizione': 'Beschreibung',
  'Conferma': 'Bestätigung',
  'Sì, revoca': 'Ja, widerrufen',
  'Revocare veramente il token': 'Token wirklich widerrufen',
  'senza nome': 'ohne Namen',
  "? L'azione è irreversibile.": '? Die Aktion ist unwiderruflich.',
  'Caricamento…': 'Wird geladen…',
  'Nessun token': 'Kein Token',
  'Creazione': 'Erstellung',
  'Scadenza': 'Ablauf',
  'Ultimo utilizzo': 'Zuletzt verwendet',
  'Ambiti': 'Bereiche',
  'Illimitato': 'Unbegrenzt',
  'Non ancora in uso': 'Noch nicht verwendet',
  'scope': 'Scopes',
  'Elimina il token': 'Token löschen',
  'Informazioni aggiornate': 'Informationen aktualisiert',
  'Token revocato': 'Token widerrufen',
  'Crea un token': 'Token erstellen',
  'Gestione dei token API': 'API-Token-Verwaltung',
  "L'API NeoFlux ti consente di gestire i prodotti tramite le tue interfacce senza passare dal Manager.": 'Mit der NeoFlux-API verwalten Sie Ihre Produkte über Ihre eigenen Schnittstellen, ohne den Manager zu nutzen.',
  'Consulta la documentazione.': 'Zur Dokumentation.',
  "Un token consente di consultare l'API NeoFlux con il proprio account utente. Il codice ottenuto è": 'Mit einem Token greifen Sie mit Ihrem Benutzerkonto auf die NeoFlux-API zu. Der erhaltene Code ist',
  'riservato': 'vertraulich',
  'e non deve essere divulgato per nessuna ragione.': 'und darf unter keinen Umständen weitergegeben werden.',
  'token': 'Token',
  "Cerca un'applicazione o uno scope": 'Anwendung oder Scope suchen',
  'Creazione di un token': 'Erstellung eines Tokens',
  'Per creare il tuo token compila i campi sottostanti:': 'Füllen Sie die folgenden Felder aus, um Ihren Token zu erstellen:',
  'Nome del token (facoltativo)': 'Token-Name (optional)',
  'Applicazione *': 'Anwendung *',
  'Ambiti *': 'Bereiche *',
  'Rimuovi': 'Entfernen',
  'Cercare uno scope': 'Einen Scope suchen',
  'Tutti': 'Alle',
  'Tutti gli scope selezionati': 'Alle Scopes ausgewählt',
  'Durata di validità *': 'Gültigkeitsdauer *',
  '1 ora': '1 Stunde',
  '1 giorno': '1 Tag',
  '1 mese': '1 Monat',
  '6 mesi': '6 Monate',
  '1 anno': '1 Jahr',
  'Descrizione (facoltativa)': 'Beschreibung (optional)',
  'Crea il token': 'Token erstellen',
  'Password di accesso': 'Zugangspasswort',
  'Inserisci la password del tuo account per creare il token.': 'Geben Sie das Passwort Ihres Kontos ein, um den Token zu erstellen.',
  'Password di accesso *': 'Zugangspasswort *',
  'Mostra password': 'Passwort anzeigen',
  'Errore durante la creazione': 'Fehler bei der Erstellung',
  'Token creato con successo': 'Token erfolgreich erstellt',
  'Token': 'Token',
  'Ricordati di copiare il tuo token: in un secondo momento non sarà più accessibile.': 'Denken Sie daran, Ihren Token zu kopieren: Er ist später nicht mehr zugänglich.',
  'Copia': 'Kopieren',
  'Applicazioni': 'Anwendungen',
  'Consulta gli accessi alle tue applicazioni': 'Zugriffe auf Ihre Anwendungen anzeigen',
  'API NeoFlux': 'NeoFlux API',
  'Leggi la documentazione per gli sviluppatori': 'Entwicklerdokumentation lesen',
  '0 token API': '0 API-Token',
};
